import { assertEvent, assign } from 'xstate';

import { removeModificationToActiveModificationsList } from '../../helpers';
import { type CustomizationMachineAction } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Handles the complete removal (including all portions) of a modification from
 * the list of active modifications within the customization context.
 */
export const removeModificationCompletely: CustomizationMachineAction = assign((args) => {
  const { context, event } = args;

  assertEvent(event, 'customization.remove-modification-completely');

  const { allModificationsMap, modifications, extrasModificationsMap } = context;
  const { ingredientId } = event;

  if (!allModificationsMap || !modifications) {
    return {};
  }

  const { active } = modifications;

  const modification = allModificationsMap.get(ingredientId);
  const extrasModification = modification?.ingredientId
    ? extrasModificationsMap.get(modification.ingredientId)
    : undefined;

  const afterExtrasRemoval = extrasModification?.ingredient
    ? removeModificationToActiveModificationsList({
        ingredientId: extrasModification.ingredient.id,
        allModificationsMap,
        activeModifications: active,
        shouldRemoveAllPortions: true,
      })
    : active;

  const updatedActives = removeModificationToActiveModificationsList({
    ingredientId,
    allModificationsMap,
    activeModifications: afterExtrasRemoval,
    shouldRemoveAllPortions: true,
  });

  return { modifications: { ...modifications, active: updatedActives } };
});
